import { render, staticRenderFns } from "./LanguageNavbar.vue?vue&type=template&id=21d1f2f0&scoped=true&"
import script from "./LanguageNavbar.vue?vue&type=script&lang=js&"
export * from "./LanguageNavbar.vue?vue&type=script&lang=js&"
import style0 from "./LanguageNavbar.vue?vue&type=style&index=0&id=21d1f2f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d1f2f0",
  null
  
)

export default component.exports